import locals from "../../localization/localization_en_lean_startup_canvas.json"

const locals_lsc = locals.lean_startup_canvas;

export const colorPalette = ["bg-[#EBF1FF]", "bg-[#FEF2C0]", "bg-[#F3E8FC]"]

export const stickyNotesPalette = {
  [locals_lsc.mertics[0].title]: { color: "bg-[#D7C3FF]" },
  [locals_lsc.mertics[1].title]: { color: "bg-[#FFF598]" },
  [locals_lsc.mertics[2].title]: { color: "bg-[#C6FFDB]" },
  [locals_lsc.mertics[3].title]: { color: "bg-[#FFC978]" },
  [locals_lsc.mertics[4].title]: { color: "bg-[#F4939B]" },
  [locals_lsc.mertics[5].title]: { color: "bg-[#F8E964]" },
  [locals_lsc.mertics[6].title]: { color: "bg-[#FCCEDD]" },
  [locals_lsc.mertics[7].title]: { color: "bg-[#B1CAFF]" },
  [locals_lsc.mertics[8].title]: { color: "bg-[#FFC978]" }
};